import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Carousel} from "react-responsive-carousel";
import SPPerformance from "../../components/Charts/OnTheMarket/SPPerformance";
import SPPCharacteristics from "../../components/Charts/OnTheMarket/SPPCharacteristics";
import './SPPCharts.scss';

class SPPCharts extends Component {

    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        match: PropTypes.object.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        history: PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps){
        const currentPath = this.props.history.location.pathname.replace(`/${this.props.match.params.id}`, '');
        const updatedPath = nextProps.history.location.pathname.replace(`/${nextProps.match.params.id}`, '');

        return currentPath !== updatedPath;
    }

    updateHistory = sliderNumber => {
        const {id} = this.props.match.params;
        if (sliderNumber === id) return;
        const url = this.props.match.path.replace(':id', sliderNumber);
        this.props.history.push(url);
    };

    render() {
        const {id} = this.props.match.params;

        return (
            <div>
                <h2 style={{textAlign: 'center'}}>S&P 500</h2>
                <p>
                    The S&P 500®/MarketAxess Investment Grade Corporate Bond Index is a market value-weighted subset of
                    the S&P500 Investment Grade Corporate Bond Index that seeks to measure the performance of corporate
                    debt issued in the U.S. by S&P 500 companies.
                </p>
                <Carousel showArrows
                          showIndicators={false}
                          swipeable={false}
                          emulateTouch={false}
                          showThumbs={false}
                          showStatus={false}
                          onChange={this.updateHistory}
                          selectedItem={Number(id)}>
                    <div className="sppCharts">
                        <div className="sppCharts__chart">
                            <SPPerformance/>
                        </div>
                        <div className="sppCharts__table">
                            <SPPCharacteristics/>
                        </div>
                    </div>
                </Carousel>
            </div>
        );
    }
}

export default SPPCharts;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/SPPCharts.jsx